import { _, moment, Radio, Backbone, CountryList, $ } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";
import { Backform, Biscuit, Notification, Dependencies } from "../../utils";
import Locations from "../../collections/Locations";

import User from "../../models/User";

import OffCanvasBehavior from "../../behaviors/Behavior.OffCanvas";

import OffCanvasUsersFormTpl from "../../templates/users/OffCanvasUsersFormTpl.html";
import Users from "../../collections/Users";
import { getApiHost } from "../../Sync";
import { generateClientHash } from "../../utils/Uri";
import t from "../../react/helpers/t";

export default InboomaBaseView.extend({
  template: OffCanvasUsersFormTpl,
  parentView: "users", // For routing back
  el: "#inb-off-canvas",

  ui: {
    userAddOrderBtn: "#user-add-order-btn",
    resetPasswordBtn: ".button-reset-password",
    changeUserRoleSelect: ".form-control",
  },

  events: {
    "click @ui.userAddOrderBtn": "_addOrderToUser",
    "change @ui.changeUserRoleSelect": "_changUserRole",
    "click #swisspass-registration-btn": "_swisspassRegistration",
  },

  _tasks: [],

  _matrixFields: [],

  _allLocations: null,

  _swisspassRegistration(ev) {
    ev.stopImmediatePropagation();

    // example link:
    // https://test-general-frontend.inbooma.net/?hash=74b907031988fdbbba16fc26baaec36eb18c1b332&redirectTo=https://test-web.inbooma.net/users/add#/login-with-swisspass

    console.log("client id: ", Biscuit.get("user.client_id"));
    // https://test-general-frontend.inbooma.net?hash={CLIENT_ID_HASH_HERE}&redirectTo={WEB_FRONTEND_URL_HERE}#/login-with-swisspass
    var url_base,
      redirection,
      clientHash = generateClientHash(Biscuit.get("user.client_id"));
    console.log("client hash: ", clientHash);

    var host = getApiHost();

    if (host.indexOf("test") >= 0) {
      // test environment
      url_base = "https://test-general-frontend.inbooma.net";
      redirection = "https://test-web.inbooma.net/users";
    } else if (host.indexOf("staging") >= 0) {
      // staging environment
      url_base = "https://staging-general-frontend.inbooma.net"; // what's the url to choose here?
      redirection = "https://staging-web.inbooma.net/users";
    } else {
      // this should be live environment
      url_base = "https://general-frontend.inbooma.net"; // what's the url to choose here?
      redirection = "https://web.inbooma.net/users";
    }
    var win = window.open(
      url_base + "?hash=" + clientHash + "&redirectTo=" + redirection + "#/login-with-swisspass",
      "_blank",
    );
    win.focus();
  },

  // adds a new row under each membership row which contains date of last modification
  _addMembershipInfoBar() {
    var infoBars = document.getElementsByClassName("membership-info");

    for (var i = 0; i < infoBars.length && i < this.model.attributes.memberships.length; i++) {
      var modified = this.model.attributes.memberships[i].modified;
      var container = document.createElement("div");
      container.className = "inb-c-subtext row float-left";
      var infoLabel = document.createElement("span");
      infoLabel.innerHTML = this.t("last_modified_at") + " ";

      if (modified !== null && modified !== undefined) {
        infoLabel.innerHTML += modified;
      }
      container.appendChild(infoLabel);
      infoBars[0].parentNode.appendChild(container);
    }
  },

  _checkForSwisspassMembership() {
    var elements = document.getElementsByClassName("form-control");
    var elementNamePrefix = null;

    for (var i = 0; i < this.model.attributes.memberships.length; i++) {
      if (this.model.attributes.memberships[i].name == "Swisspass") {
        // swisspass membership found - get UI element and set to uneditable

        for (var j = 0; j < elements.length; j++) {
          if (elements[j].value == "Swisspass") {
            // swisspass UI element found - get name prefix to access input fields
            elementNamePrefix = elements[j].name.slice(0, -4); // remove 'name' from attribute value
            console.log("element name: ", elementNamePrefix);
            elements[j].setAttribute("readonly", "");
          }
          if (
            elementNamePrefix != null &&
            elements[j].name == elementNamePrefix + "external_customer_id"
          ) {
            elements[j].setAttribute("readonly", "");
          }
          if (
            elementNamePrefix != null &&
            elements[j].name == elementNamePrefix + "subscriptions"
          ) {
            elements[j].setAttribute("readonly", "");
          }
        }

        if (elementNamePrefix != null) {
          document.getElementById(elementNamePrefix + "statusSwitch").setAttribute("disabled", "");
        }

        return;
      }
    }
  },

  _addUserLog() {
    const emailElement = document.getElementsByClassName("form-field-email")[0];
    const serviceLogContainer = document.getElementById("user-form-service-container");

    if (
      emailElement === undefined ||
      emailElement == null ||
      serviceLogContainer === undefined ||
      serviceLogContainer == null
    )
      return;

    // move user log inside form
    emailElement.after(serviceLogContainer);
    serviceLogContainer.classList.remove("hide");
  },

  _addOrderToUser() {
    this.$el.html("");
    this.canvas.close();
  },

  _changUserRole(ev) {
    ev.stopImmediatePropagation();

    if (ev.target.name === "role") {
      if (this.model.get("role") != "manager-location") {
        this.$("._backform_user_locations").addClass("hide"); // hide locations field
      } else {
        this.$("._backform_user_locations").removeClass("hide"); // show locations field
      }
      if (this.model.get("role") != "mediator") {
        this.$(document.getElementsByClassName("contract.fee_percentage")[0]).addClass("hide"); // hide provision field
      } else {
        this.$(document.getElementsByClassName("contract.fee_percentage")[0]).removeClass("hide"); // show provision field
      }
      this._checkUserRequired();
    }

    if (ev.target.name === "_backform_user_locations") {
      console.log("change user location:  seleceted index: " + ev.target.selectedIndex);
      console.log("location: " + this.model.attributes._backform_user_locations);
      if (ev.target.selectedIndex < 0) {
        this.model.attributes._backform_user_locations = undefined;
        this.model.attributes.user_locations = []; // reset locations
      }
    }
  },

  _checkUserRequired() {
    let selectedRole;
    const elem = this.$("select[name=role]")[0];

    if (elem === undefined || elem === null) {
      // user role is 'user' by default
      selectedRole = this.model.get("role");
    } else {
      selectedRole = elem.options[elem.selectedIndex].value;
    }

    // field username not required for user
    if (selectedRole === '"user"' || selectedRole === "user") {
      this.$("input[name=username]").removeAttr("required");
    } else {
      this.$("input[name=username]").attr("required", "required");
    }
    // add provision field for mediator
    if (selectedRole === '"mediator"' || selectedRole === "mediator") {
    }
  },

  _requestingPasswordInProgress: false,

  _resetOwnPassword(pwd) {
    if (this._requestingPasswordInProgress) {
      return;
    }

    this._requestingPasswordInProgress = true;

    const that = this;

    const SubmitPasswordModel = Backbone.Model.extend({
      urlRoot: "/users/savePassword",
    });

    const submitPasswordModel = new SubmitPasswordModel({
      hash: btoa(Biscuit.get("user.id")),
      password: pwd,
    });

    submitPasswordModel.save(null, {
      success(model, response) {
        that._requestingPasswordInProgress = false;

        if (response.success === true) {
          new Notification({
            message: that.t("new_password_success"),
            duration: 5000,
            type: "success",
            closeable: true,
            icon: "fi fi-torso",
          });
        } else {
          that.$el
            .find(".off-canvas__form-error")
            .removeClass("hide")
            .html(that.t("password_reset_invalid"));

          that.$el.find('input[name="_new_password_1"]').addClass("is-invalid-input");
          that.$el.find('input[name="_new_password_2"]').addClass("is-invalid-input");
        }
      },

      error(model, reponse) {
        that._requestingPasswordInProgress = false;

        alert("Problem resetting your password. Please try again later.");
      },
    });
  },

  _throwUsernameUniqueError() {
    if (this.$("input[name=username]").attr("required") === undefined)
      //return;

      new Notification({
        message: this.t("user_error_unique_username"),
        duration: 5000,
        type: "warning",
        closeable: true,
        icon: "fi fi-torso",
      });

    this.$el.find('input[name="username"]').addClass("is-invalid-input");
  },

  _throwUsernameMinimumError() {
    new Notification({
      message: this.t("user_error_short_username"),
      duration: 5000,
      type: "warning",
      closeable: true,
      icon: "fi fi-torso",
    });

    this.$el.find('input[name="username"]').addClass("is-invalid-input");
  },

  _throwMailUniqueError() {
    new Notification({
      message: this.t("user_error_unique_mail"),
      duration: 5000,
      type: "warning",
      closeable: true,
      icon: "fi fi-mail",
    });

    this.$el.find('input[name="email"]').addClass("is-invalid-input");
  },

  behaviors: [
    {
      behaviorClass: OffCanvasBehavior,
      extraHeaderRegionContent: `
      | <%= t(role === 'user' ? 'kunden_nbr' : 'user_nbr') %>: <%- role === 'user' ? customer_nbr : id %>`,
      openCanvas: (view) => {
        if (typeof view.options.openCanvas != "undefined") {
          return view.options.openCanvas;
        }
        return true;
      },
      beforeSave: (model) => {
        // As you see, this is a hacky way of doin' things
        // Instead, use approach from ReservationsList and create
        // a clone consisting only of whitelisted attributes
        delete model.attributes.api_token;
        delete model.attributes.activation_date;
        delete model.attributes.secret;
        delete model.attributes.secret_verified;
        delete model.attributes.tos_date;
        delete model.attributes.password;
        delete model.attributes._new_password_1;
        delete model.attributes._new_password_2;
        delete model.attributes.clients;
        delete model.attributes.is_superuser;
        delete model.attributes._listItemContent;
        model.attributes.isWebFE = true;

        if (
          model.get("username") === undefined ||
          model.get("username") === null ||
          model.get("username") === ""
        ) {
          delete model.attributes.username;
        }

        if (model.get("id") === null) {
          model.set("client_id", Number(Biscuit.get("user.client_id")));
        }
        if (model.attributes.role != "mediator") {
          delete model.attributes.contract; // remove attribute contract for none-mediators
        } else {
          console.log("mediator: ", model.attributes);
          model.attributes.contract.fee_percentage =
            parseFloat(model.attributes.contract.fee_percentage) / 100;

          console.log("after change of percentage: ", model.attributes);
        }

        if (
          Biscuit.get("client.isVehicleOwner") !== "true" ||
          Biscuit.get("user.role") != "admin" ||
          model.get("role") == "user"
        ) {
          delete model.attributes.user_locations; // remove attribute for none-admin users
        } else {
          if (typeof model.attributes._backform_user_locations !== "undefined") {
            model.attributes.user_locations = [];
            if (
              model.attributes._backform_user_locations > 0 &&
              typeof model.attributes._backform_user_locations.length === "undefined"
            ) {
              // transform to object if a location is stored as number
              model.attributes.user_locations.push({
                location_id: model.attributes._backform_user_locations,
              });
            } else if (
              model.attributes._backform_user_locations.length > 0 &&
              model.attributes._backform_user_locations[0].id != "-1"
            ) {
              // re-format user_loations as required by API
              _.each(model.attributes._backform_user_locations, function (location) {
                model.attributes.user_locations.push({ location_id: Number(location.id) });
              });
            }
          } else {
            model.set("user_locations", []);
          }
        }
        delete model.attributes._backform_user_locations;
      },
      afterSaveSuccess: (model, view, response) => {
        // POST /users/userRegistration returns data[0]
        // POST /users returns data

        if (typeof response.data[0] != "undefined") {
          model = new User(response.data[0]);
        } else {
          model = new User(model.toJSON());
        }

        if (model.get("created") == "" || _.isNull(model.get("created"))) {
          model.set("created", moment().toISOString());
        }

        if (model.get("role") == "manager" || model.get("role") == "admin") {
          // Route directly to staffs page
          view.parentView += "/staff";
        }

        if (typeof view.collection !== "undefined") {
          // If we come here from "My profile settings" link,
          // we may not have yet a global collection
          // e.g. when logged in user has role "user"
          view.collection.set(model, { add: true, merge: true, remove: false });
        }
        let msg =
          view.t(view.isNew ? "saved_${a}" : "updated_${a}", { a: view.t("user") }, "capital") +
          ' "' +
          model.get("username") +
          '". ' +
          (view.isNew && model.get("active") ? view.t("user_registration_mail_sent") : "");
        if (
          model.get("email") === undefined ||
          model.get("email") === null ||
          model.get("email") == ""
        ) {
          msg =
            view.t(view.isNew ? "saved_${a}" : "updated_${a}", { a: view.t("user") }, "capital") +
            ".";
        }
        new Notification({
          message: msg,
          duration: 5000,
          type: "success",
          closeable: true,
          icon: "fi fi-check",
        });

        // if model.get('role') == manager || admin
        // Backbone.history.navigate('users/staff');
      },
      afterSaveError: (model, view, response) => {
        view.$el.find(".rollingLoader").fadeOut("fast");

        if (
          typeof response.responseJSON.data !== "undefined" &&
          typeof response.responseJSON.data.errors !== "undefined"
        ) {
          if (response.responseJSON.success === false) {
            _.each(response.responseJSON.data.errors, (type, code) => {
              switch (code) {
                case "email":
                  // if (typeof type._isUnique !== 'undefined) {
                  view._throwMailUniqueError();
                  break;

                case "username":
                  if (typeof type._isUnique !== "undefined") {
                    view._throwUsernameUniqueError();
                  } else if (typeof type.regex !== "undefined") {
                    view._throwUsernameMinimumError();
                  }
                  break;
              }
            });
          }
        } else {
          new Notification({
            message: view.t("request_error"),
            duration: 5000,
            type: "warning",
            closeable: true,
            icon: "fi fi-x",
          });
        }
      },
    },
  ],

  initialize() {
    this.isNew = this.model.get("id") == "";

    if (this.model.attributes.contract == null) {
      console.log("init model: ", this.model);
      this.model.attributes.contract = { fee_percentage: "0" };
    }
    console.log("after: ", this.model.attributes);

    this.model.attributes.contract.fee_percentage = (
      parseFloat(this.model.attributes.contract.fee_percentage) * 100
    ).toString();
    console.log("after percentage: ", this.model.attributes);
    if (this.model.get("id") == "") {
      // Inherit default language from its client
      this.model.set("lang", Biscuit.get("user.lang"));

      if (Biscuit.get("client.country") !== "") {
        this.model.attributes.user_addresses.push({ country: Biscuit.get("client.country") });
      }
    }
    this.render();

    if (this.isNew) return;

    const that = this;

    // fetch order tasks
    const RequestHelper = Backbone.Model.extend({
      urlRoot: "/tasks?includes=Users&fk_model=Users&fk_id=" + this.model.get("id"),
    });

    new RequestHelper(null).fetch({
      success(model, response) {
        if (response.success && response.data.length > 0) {
          // put tasks into list of tasks
          that._tasks = [];
          for (var i = 0; i < response.data.length; i++) {
            that._tasks.push(response.data[i]);
          }
          that.render();
        } else {
          console.log("ERROR: failed to get tasks response or no tasks available");
        }
      },
      error(model, response) {
        console.log("Error, could not request tasks.");
      },
    });
  },

  templateContext() {
    return {
      is_own_user: Biscuit.get("user.id") === this.model.get("id"),
      created_printable: moment(this.model.get("created")),
      modified_printable: moment(this.model.get("modified")),
      role: Biscuit.get("user.role"),
      _tasks: this._tasks,
      hasTaskPermission: (val) => {
        const role = Biscuit.get("user.role");
        if (role == "user" && val == "write") return false;
        if (role == "user" && val == "edit") return false;
        return true;
      },
      moment,
    };
  },

  onRender() {
    const that = this;

    let user_roles = [
      { label: this.t("user", null, "capital"), value: "user" },
      { label: this.t("manager", null, "capital"), value: "manager" },
      { label: this.t("role_booking-manager", null, "capital"), value: "booking-manager" },
      // { label : this.t('guide',null,'capital'), value : 'guide' },
      { label: this.t("mediator", null, "capital"), value: "mediator" },
      //{ label : this.t('role_garage-staff',null,'capital'), value : 'garage-staff'},
    ];

    if (Number(Biscuit.get("user.client_id")) == 28) {
      user_roles.push({
        label: this.t("role_garage-staff", null, "capital"),
        value: "garage-staff",
      });
    }

    if (Biscuit.get("user.role") == "admin") {
      user_roles.push({ label: this.t("admin", null, "capital"), value: "admin" });
    }
    if (Biscuit.get("client.isVehicleOwner") == "true") {
      user_roles.push({
        label: this.t("role_manager-location", null, "capital"),
        value: "manager-location",
      });
    }

    const isOwnUser = Biscuit.get("user.id") === this.model.get("id");

    let country_list = [
      {
        label: "",
        value: "",
      },
    ];

    const language = Biscuit.get("user.lang").split("_");
    let managerLocations = Biscuit.get("user.user_locations");
    let l = managerLocations.split(",");
    let webtype = "&webname=default";
    const inArray = (needle, haystack) => {
      let length = haystack.length;
      for (let i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    };
    /*if(inArray(593,l)){
      webtype = '&webname=suvretta';
    }*/
    const MatrixFieldsModel = Backbone.Model.extend({
      urlRoot:
        "/matrix_fields?client_id=" + Biscuit.get("user.client_id") + "&active_be=1" + webtype,
    });

    let matrixFields = [];
    const matrixFieldsRequest = new MatrixFieldsModel().fetch({
      headers: {
        "Accept-Language": Biscuit.get("user.lang"),
      },
      success(model, response) {
        _.each(response.data, function (val, index) {
          matrixFields[val.name] = val;
        });
        that._matrixFields = matrixFields;
        let index_counter = 0;

        _.each(CountryList.getNames(language[0]), (key, val) => {
          country_list.push({
            label: key,
            value: val,
          });

          index_counter++;

          if (key == Biscuit.get("client.country")) {
            index = index_counter;
          }
        });

        let fields = [];
        if (typeof matrixFields["username"] !== "undefined") {
          fields.push({
            name: "username",
            label: matrixFields["username"].display_name,
            control: "input",
            helpMessage: that.model.get("username") == "" ? that.t("no_special_char_allowed") : "",
            required: matrixFields["username"].required_be,
            showAsterisk: matrixFields["username"].required_be,
            disabled:
              that.model.get("id") != "" &&
              that.model.get("username") != "" &&
              that.model.get("username") != "undefined" &&
              that.model.get("username") != null,
            size: {
              large: "4",
            },
          });
        }
        fields.push(
          {
            name: "role",
            label: that.t("user_role", null, "capital"),
            control: "select",
            required: true,
            // Hide field when it's part of QuickOrdersForm
            visible: typeof that.options.openCanvas == "undefined" || that.options.openCanvas,
            options: user_roles,
            rbac: "change-role",
            size: {
              large: "3",
            },
          },
          {
            name: "contract.fee_percentage",
            label: that.t("provision", null, "capital") + " (%)",
            control: "input",
            rbac: "write",
            size: {
              large: "2",
            },
          },
          {
            name: "lang",
            label: that.t("language", null, "capital"),
            control: "select",
            required: true,
            options: [
              { label: that.t("en_GB"), value: "en_GB" },
              { label: that.t("de_DE"), value: "de_DE" },
              { label: that.t("fr_FR"), value: "fr_FR" },
            ],
            size: {
              large: "3",
            },
          },
        );
        if (typeof matrixFields["title"] !== "undefined") {
          fields.push({
            name: "title",
            label: matrixFields["title"].display_name,
            showAsterisk: matrixFields["title"].required_be,
            control: "select",
            required: matrixFields["title"].required_be,

            options: [
              {
                label: "",
                value: "",
              },
              {
                label: that.t("user_title_mr"),
                value: "mr",
              },
              {
                label: that.t("user_title_mrs"),
                value: "mrs",
              },
              {
                label: that.t("user_title_mx"),
                value: "mx",
              },
              {
                label: that.t("user_title_family"),
                value: "family",
              },
              {
                label: that.t("user_title_company"),
                value: "company",
              },
            ],
            size: {
              large: "3",
            },
          });
        }

        if (typeof matrixFields["employee_number"] !== "undefined") {
          fields.push({
            name: "employee_number",
            label: matrixFields["employee_number"].display_name,
            control: "input",
            required: matrixFields["employee_number"].required_be,
            showAsterisk: matrixFields["employee_number"].required_be,
            size: {
              large: "4",
            },
          });
        }

        if (typeof matrixFields["first_name"] !== "undefined") {
          fields.push({
            name: "first_name",
            label: matrixFields["first_name"].display_name,
            control: "input",
            required: matrixFields["first_name"].required_be,
            showAsterisk: matrixFields["first_name"].required_be,
            size: {
              large: "4",
            },
          });
        }

        if (typeof matrixFields["last_name"] !== "undefined") {
          fields.push({
            name: "last_name",
            label: matrixFields["last_name"].display_name,
            control: "input",
            required: matrixFields["last_name"].required_be,
            showAsterisk: matrixFields["last_name"].required_be,
            size: {
              large: "5",
            },
          });
        }

        if (typeof matrixFields["company"] !== "undefined") {
          fields.push({
            name: "company",
            label: matrixFields["company"].display_name,
            control: "input",
            required: matrixFields["company"].required_be,
            showAsterisk: matrixFields["company"].required_be,
            size: {
              large: "5",
            },
          });
        }
        if (typeof matrixFields["email"] !== "undefined") {
          fields.push({
            name: "email",
            label: matrixFields["email"].display_name,
            control: "input",
            pattern: "email",
            required: matrixFields["email"].required_be,
            showAsterisk: matrixFields["email"].required_be,
            groupLabel: '<i class="fi fi-mail"></i>',
            extraTopClasses: ["form-field-email"],
            size: {
              large: "7",
            },
          });
        }
        if (typeof matrixFields["birthdate"] !== "undefined") {
          fields.push({
            name: "birthdate",
            label: matrixFields["birthdate"].display_name,
            control: "input",
            required: matrixFields["birthdate"].required_be,
            showAsterisk: matrixFields["birthdate"].required_be,
            groupLabel: '<i class="fi fi-mail"></i>',
            size: {
              large: "6",
            },
          });
        }
        if (typeof matrixFields["id_card_nbr"] !== "undefined") {
          fields.push({
            name: "id_card_nbr",
            label: matrixFields["id_card_nbr"].display_name,
            control: "input",
            required: matrixFields["id_card_nbr"].required_be,
            showAsterisk: matrixFields["id_card_nbr"].required_be,
            size: {
              large: "6",
            },
          });
        }
        if (Biscuit.get("user.role") == "admin" || Biscuit.get("user.role") == "manager") {
          fields.push({
            name: "active",
            label: that.t("user_active"),
            control: "boolean",
            value: true,
            helpMessage: that.t("user_active_body"),
            // extraTopClasses: ['small-offset-2'],
            rbac: "write",
            size: {
              large: "6",
            },
          });
        }

        fields.push({
          control: "spacer",
        });

        if (
          isOwnUser &&
          (typeof that.options.openCanvas == "undefined" || that.options.openCanvas)
        ) {
          // Show "Change password" container only for logged in user who is NOT in another mask/context
          fields.push(
            {
              name: "_new_password_1",
              control: "password",
              label: that.t("new_password"),
              helpMessage: that.t("new_password_help"),
              size: {
                large: "6",
              },
            },
            {
              name: "_new_password_2",
              control: "password",
              label: that.t("new_password_confirm"),
              size: {
                large: "6",
              },
            },
            {
              control: "button",
              label: that.t("new_password_submit"),
              type: "",
              extraClasses: ["change-pwd-btn"],
            },
            {
              control: "spacer",
            },
          );
        }

        if (Biscuit.get("user.role") == "admin" && Biscuit.get("client.isVehicleOwner") == "true") {
          if (typeof that.model.attributes.user_locations == "undefined") {
            that.model.attributes.user_locations = [];
          }

          const locations = Radio.channel("locations").request("get:data");

          if (typeof locations === "undefined") {
            if (that._allLocations === null) {
              // fetch locations
              const RequestHelper = Backbone.Model.extend({
                urlRoot: "/locations?findForSelect=true&find=short&limit=999&page=1",
              });

              new RequestHelper(null).fetch({
                success(model, response) {
                  if (response.success && response.data.length > 0) {
                    // Generate list of all locations, sorted by name
                    let locations = new Locations(response.data);
                    that._allLocations = _.sortBy(
                      _.map(locations.models, (location) => {
                        if (location.get("name") != "" && location.get("name") != null) {
                          return { label: location.get("name"), value: location.get("id") };
                        } else {
                          return {};
                        }
                      }),
                      (location) => location.label,
                    );
                    that.render();
                  } else {
                    console.log(
                      "ERROR: failed to get locations response or no locations available",
                    );
                  }
                },
                error(model, response) {
                  console.log("Error, could not request locations.");
                },
              });
              that._allLocations = [];
            }
          } else {
            // Generate list of all locations, sorted by name
            that._allLocations = _.sortBy(
              _.map(locations.models, (location) => {
                if (location.get("name") != "" && location.get("name") != null) {
                  return { label: location.get("name"), value: location.get("id") };
                } else {
                  return {};
                }
              }),
              (location) => location.label,
            );
          }

          if (typeof that.model.attributes._backform_user_locations == "undefined") {
            if (that.model.get("user_locations").length == 0) {
              // _.map causes problems for empty locations
              that.model.set("_backform_user_locations", [{ id: -1 }]); // seems to be the only way to select nothing without causing problems
            } else {
              that.model.set(
                "_backform_user_locations",
                _.map(that.model.get("user_locations"), (_location) => {
                  return { id: _location.location_id };
                }),
              );
            }
          }

          fields.push({
            name: "_backform_user_locations",
            control: "selector",
            label: that.t("location_list_manager", null, "capital"),
            helpMessage: that.t("location_list_manager_help"),
            required: false,
            hasMultiple: () => 999,
            placeholder: that.t("select_${a}", { a: that.t("location") }),
            options: that._allLocations,
            size: {
              large: "12",
              small: "12",
            },
          });
        }

        const hasPrivacyAccepted =
          that.model.get("privacy_accepted") !== null && that.model.get("privacy_accepted") !== "";

        fields.push(
          {
            name: "newsletter",
            control: "boolean",
            label: that.t("user_has_newsletter"),
            size: {
              large: "2",
              small: "6",
            },
          },
          /*{
        name: "id_card_nbr",
        control: "input",
        label: that.t('user_customer_nbr'),
        size : {
          "large" : "5",
          "small" : "12"
        },
      },*/
          {
            name: "_privacy_accepted",
            control: "uneditable-input",
            label: hasPrivacyAccepted
              ? '<i class="fi fi-check"></i> ' +
                that.t("user_privacy_accepted_yes") +
                " " +
                moment(that.model.get("privacy_accepted")).format("DD.MM.YYYY, HH:mm")
              : '<i class="fi fi-x"></i> ' + that.t("user_privacy_accepted_no"),
            disabled: hasPrivacyAccepted,
            size: {
              large: "5",
              small: "6",
            },
          },
        );
        if (typeof matrixFields["street"] !== "undefined") {
          fields.push({
            name: "user_addresses.0.street",
            control: "input",
            label: matrixFields["street"].display_name,
            required: matrixFields["street"].required_be,
            showAsterisk: matrixFields["street"].required_be,
            size: {
              large: "8",
            },
          });
        }
        if (typeof matrixFields["house_number"] !== "undefined") {
          fields.push({
            name: "user_addresses.0.house_number",
            control: "input",
            label: matrixFields["house_number"].display_name,
            required: matrixFields["house_number"].required_be,
            showAsterisk: matrixFields["house_number"].required_be,
            size: {
              large: "2",
            },
          });
        }
        if (typeof matrixFields["country"] !== "undefined") {
          fields.push({
            name: "user_addresses.0.country",
            control: "select",
            label: matrixFields["country"].display_name,
            options: country_list,
            required: matrixFields["country"].required_be,
            showAsterisk: matrixFields["country"].required_be,
            size: {
              large: "4",
            },
          });
        }
        if (typeof matrixFields["city"] !== "undefined") {
          fields.push({
            name: "user_addresses.0.city",
            control: "input",
            label: matrixFields["city"].display_name,
            required: matrixFields["city"].required_be,
            showAsterisk: matrixFields["city"].required_be,
            size: {
              large: "4",
            },
          });
        }
        if (typeof matrixFields["zip_code"] !== "undefined") {
          fields.push({
            name: "user_addresses.0.zip_code",
            control: "input",
            label: matrixFields["zip_code"].display_name,
            required: matrixFields["zip_code"].required_be,
            showAsterisk: matrixFields["zip_code"].required_be,
            size: {
              large: "2",
            },
          });
        }
        if (typeof matrixFields["phone_number"] !== "undefined") {
          fields.push({
            name: "user_addresses.0.phone_number",
            control: "input",
            label: matrixFields["phone_number"].display_name,
            required: matrixFields["phone_number"].required_be,
            showAsterisk: matrixFields["phone_number"].required_be,
            size: {
              large: "5",
            },
          });
        }
        if (typeof matrixFields["mobile"] !== "undefined") {
          fields.push({
            name: "user_addresses.0.mobile",
            control: "input",
            label: matrixFields["mobile"].display_name,
            required: matrixFields["mobile"].required_be,
            showAsterisk: matrixFields["mobile"].required_be,
            size: {
              large: "5",
            },
          });
        }

        fields.push(
          {
            control: "spacer",
          },
          {
            name: "memberships.0.status",
            control: "boolean",
            label: that.t("membership_active", null, "capital"),
            size: {
              large: "2",
            },
          },
          {
            name: "memberships.0.name",
            control: "input",
            label: that.t("type_of_membership"),
            size: {
              large: "4",
            },
          },
          {
            name: "memberships.0.external_customer_id",
            control: "input",
            label: that.t("user_customer_nbr", null, "capital"),
            size: {
              large: "4",
            },
          },
          {
            name: "memberships.0.subscriptions",
            control: "input",
            label: that.t("user_abo", null, "capital"),
            size: {
              large: "2",
            },
            extraTopClasses: ["membership-info"],
          },
        );

        that.form = new Backform.Form({
          el: that.$el.find("form"),
          model: that.model,
          fields: fields,
          events: {
            'keypress input[name="username"]'(e) {
              // Do NOT allow special chars || space
              // BUT allow Umlaut
              $('input[name="username"]').css("border-color", "#e3e3e3");
              let k = e.which;
              return (
                (k > 64 && k < 91) ||
                (k > 96 && k < 123) ||
                k == 8 ||
                (k >= 48 && k <= 57) ||
                k == 0 ||
                k == 186 ||
                k == 192 ||
                k == 222 ||
                k == 228 ||
                k == 252 ||
                k == 246
              );
            },
            'keypress input[name="first_name"]'(e) {
              $('input[name="first_name"]').css("border-color", "#e3e3e3");
            },
            'keypress input[name="last_name"]'(e) {
              $('input[name="last_name"]').css("border-color", "#e3e3e3");
            },
            'change select[name="title"]'(e) {
              $('select[name="email"]').css("border-color", "#e3e3e3");
            },
            'change select[name="country"]'(e) {
              $('select[name="country"]').css("border-color", "#e3e3e3");
            },
            'keypress input[name="email"]'(e) {
              $('input[name="email"]').css("border-color", "#e3e3e3");
            },
            'keypress input[name="company"]'(e) {
              $('input[name="company"]').css("border-color", "#e3e3e3");
            },
            'keypress input[name="street"]'(e) {
              $('input[name="street"]').css("border-color", "#e3e3e3");
            },
            'keypress input[name="city"]'(e) {
              $('input[name="city"]').css("border-color", "#e3e3e3");
            },
            'keypress input[name="phone_number"]'(e) {
              $('input[name="phone_number"]').css("border-color", "#e3e3e3");
            },
            'keypress input[name="house_number"]'(e) {
              $('input[name="house_number"]').css("border-color", "#e3e3e3");
            },
            'keypress input[name="mobile"]'(e) {
              $('input[name="mobile"]').css("border-color", "#e3e3e3");
            },
            "click .change-pwd-btn"(e) {
              e.preventDefault();

              that.$el.find(".is-invalid-input").removeClass("is-invalid-input");
              that.$el.find(".off-canvas__form-error").addClass("hide");

              const pwd_1 = that.model.get("_new_password_1"),
                pwd_2 = that.model.get("_new_password_2");

              if (
                typeof pwd_1 !== "undefined" &&
                pwd_1 !== null &&
                typeof pwd_2 !== "undefined" &&
                pwd_2 !== null
              ) {
                if (pwd_1 !== pwd_2) {
                  that.$el.scrollTop(0);

                  that.$el
                    .find(".off-canvas__form-error")
                    .removeClass("hide")
                    .html(that.t("password_reset_identical"));

                  that.$el.find('input[name="_new_password_2"]').addClass("is-invalid-input");
                } else if (pwd_1.length < 8) {
                  // @todo further validation, see details in response

                  that.$el.scrollTop(0);

                  that.$el
                    .find(".off-canvas__form-error")
                    .removeClass("hide")
                    .html(that.t("password_reset_invalid"));

                  that.$el.find('input[name="_new_password_1"]').addClass("is-invalid-input");
                  that.$el.find('input[name="_new_password_2"]').addClass("is-invalid-input");
                } else {
                  that._resetOwnPassword(pwd_1);
                }
              } else {
                that.$el.scrollTop(0);

                that.$el
                  .find(".off-canvas__form-error")
                  .removeClass("hide")
                  .html(that.t("new_password_fill_out"));

                that.$el.find('input[name="_new_password_1"]').addClass("is-invalid-input");
                that.$el.find('input[name="_new_password_2"]').addClass("is-invalid-input");
              }
            },
          },
        }).render();
        // Take care that RBAC-methods are executed:
        that.onDomRefresh(that);

        if (that.model.get("role") != "manager-location") {
          that.$("._backform_user_locations").addClass("hide"); // hide locations field
        }
        if (that.model.get("role") != "mediator") {
          that.$(document.getElementsByClassName("contract.fee_percentage")[0]).addClass("hide");
        }
        that.model.set("_matrixFields", matrixFields);
        that._checkUserRequired();
        that._checkForSwisspassMembership();
        that._addMembershipInfoBar();
        if (document.location.href.indexOf("/users") >= 0) {
          that._addUserLog();
        }
      },
    });
  },
});
